import React from 'react';
import DocPage from './DocPage';

const sections = [
  {
    id: 'cancellations',
    title: 'Cancellations',
    body: (
      <p>
        Cancellations made more than 48 hours before a booking are eligible for a full refund.
        Within 48 hours, a 50% refund applies. No-shows are non-refundable.
      </p>
    ),
  },
  {
    id: 'mid-stay',
    title: 'Mid-stay changes',
    body: (
      <p>
        If you need to end a stay early, please speak with the team on-site. We'll do our best to
        be fair to both you and the pets in our care.
      </p>
    ),
  },
  {
    id: 'service-issues',
    title: 'Service issues',
    body: (
      <p>
        If something hasn't gone right, we want to hear from you — please write to{' '}
        <a href="mailto:shekhar@petcart.com" className="text-primary font-medium hover:underline">
          shekhar@petcart.com
        </a>{' '}
        within 7 days of your booking.
      </p>
    ),
  },
  {
    id: 'processing',
    title: 'Processing',
    body: (
      <p>Refunds are processed to the original payment method within 7–10 business days.</p>
    ),
  },
];

const RefundPolicy = () => (
  <DocPage title="Refund Policy" lastUpdated="May 2026" sections={sections} />
);

export default RefundPolicy;
